import { createSelector } from 'reselect';

import { AppState } from '../../store/store';
import { SponsorBanner } from '../models/sponsor-banner';
import { SponsorBannerState } from './sponsor-banner-reducer';

const sponsorBannersState = (state: AppState): SponsorBannerState => state.sponsorBanners;

export const sponsorBannersSelector = createSelector(sponsorBannersState, state => {
    // shuffle banners
    return state.banners
        .map<SponsorBanner>(banner => ({ key: Math.random(), ...banner }))
        .sort((a, b) => a.key - b.key);
});
